var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[(_vm.device==='mobile'&&_vm.sidebar.opened)?_c('div',{staticClass:"drawer-bg",on:{"click":_vm.handleClickOutside}}):_vm._e(),_vm._v(" "),_c('sidebar',{staticClass:"sidebar-container"}),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('div',{class:{'fixed-header':_vm.fixedHeader}},[_c('navbar')],1),_vm._v(" "),_c('app-main')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@13.7.3/~/vue-loader/lib/template-compiler?{"id":"data-v-3c596c2a","hasScoped":true,"buble":{"transforms":{}}}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
// module id = 1263
// module chunks = 72